<template>
    <div class="flats-filter-crm" v-if="flatsPage != null">
        <div class="top-header" v-if="isMobileChecker">
            <a href="#" class="link-back" @click.prevent="closeFilterMobile">
                <svgIcon name="left-arrow" class="icon-arrow-left"/>
                <span>{{flatsPage.flats_cards_info.flat_btn_filter_back}}</span>
            </a>
            <h3>{{flatsPage.flats_cards_info.flat_filter_title_name}}</h3>
            <a href="#" class="link-reset" @click.prevent="filterComplexesInDrop('all'), setActiveParam('city', 'all')"
                v-scroll-to="{
                    el: '.flats-crm-items-container',
                    offset: -110
                }">
                {{flatsPage.flats_cards_info.flat_btn_filter_reset}}
            </a>
        </div>
        <div class="section-title-new" v-if="!isMobileChecker">
            <h4 v-if="routerName != 'online-booking-details'">{{flatsPage.page_title_new}}</h4>
            <h4 v-if="routerName == 'online-booking-details' && onlinePageSetUp != null" v-html="onlinePageSetUp.online_cards_title"></h4>
            <flatsBookingCounter></flatsBookingCounter>

            <div class="counter-home" v-if="routerName == 'home'">
                <div class="counter-title" v-html="flatsPage.flats_cards_info.filter_found_title_mainpage"></div>
                <div class="counter-number">
                    <div class="current-num" v-if="flatsPagintaion.allApartments != null" v-html="getWrap_ofSTR(flatsPagintaion.allApartments)"></div>
                    <span v-else>0</span>
                </div>
            </div>
            <!-- {{complexesCodeRadioChecked}} -->
            <!-- Кнопки переключения видов -->
            <flatsBtnsView></flatsBtnsView>
            <!-- end -->
        </div>
        <div class="filter-container">
            <div class="top-head">
                <!-- {{filterDataBase}}<br> -->
                <!-- {{descSelectComplexes}}<br> -->
                <!-- {{ filterDynamicParams.descSelectComplexes }} -->
                <!-- {{ filterDynamicParams.complexesCodeRadioChecked }} -->
                <!-- {{resetComplex}} -->
                <!-- {{filterMinMaxDataSet}}<br> -->
                <!-- {{ filterDynamicParams.selectedComplexes}}<br> -->
                <!-- {{ filterMinMaxParams }} -->

                <!-- {{ filterDynamicParams.cityFilterDefault }} <br> -->
                
                <div class="dropdown-filter-items">
                    <!-- Фильтр по ГОРОДАМ -->
                    <div class="dropwdown-filter-select dropwdown-filter-select-city" v-if="filterDynamicParams.cityFilterDefault != null">
                        <h3>{{ flatsPage.flats_filters_names.city }}</h3>
                        <div class="curent-value" :class="{'open' : openDropCity}">
                            <a href="#" :class="{active : filterDynamicParams.cityActive === 'all'}" @click.prevent="openDropCity = !openDropCity, openDropComplexes = false">{{flatsPage.flats_filters_names.flat_param_all}}</a>
                            <a href="#" :class="{active : filterDynamicParams.cityActive === item.city}" v-for="(item, index) in filterDynamicParams.cityFilterDefault" :key="index" @click.prevent="openDropCity = !openDropCity, openDropComplexes = false">{{item.city}}</a>
                            <div class="drop-icon"><svgIcon name="arrow_drop" class="icon-svg"/></div>
                        </div>
                        <div class="dropdown-menu dropdown-menu-city" :class="{'open' : openDropCity}">
                            <!-- Шапка конкретного фильтра для мобильной версии -->
                            <div class="menu-top-header" v-if="mobileView">
                                <a href="#" class="link-back" @click.prevent="openDropCity = !openDropCity">
                                    <svgIcon name="left-arrow" class="icon-arrow-left"/>
                                    <span>{{flatsPage.flats_cards_info.flat_btn_filter_back}}</span>
                                </a>
                                <h3>{{flatsPage.flats_filters_names.city}}</h3>
                                <a href="#" class="link-reset" @click="filterComplexesInDrop('all'), setActiveParam('city', 'all'), openDropCity = false">
                                    {{flatsPage.flats_cards_info.flat_btn_filter_reset}}
                                </a>
                            </div>
                            <!--  Дефолтный сброс селекта -->
                            <div class="item-R">
                                <input type="radio" :id="'city_all'" :value="true" v-model="filterDynamicParams.resetCity">
                                <label :for="'city_all'" @click="filterComplexesInDrop('all'), setActiveParam('city', 'all'), openDropCity = false">{{flatsPage.flats_filters_names.flat_param_all_cityes}}</label>
                            </div>
                            <!-- END-->
                            <div class="item-R" v-for="(item, index) in filterDynamicParams.cityFilterDefault" :key="index">
                                <input type="radio" :id="'city_' + item.code" :value="item.code" v-model="filterDynamicParams.cityCodesRadioChecked">
                                <label :for="'city_' + item.code" @click="filterComplexesInDrop(item.code), setActiveParam('city', item.city), openDropCity = false">{{item.city}}</label>
                            </div>
                        </div>
                    </div>
                    <!-- END -->
                    <!-- Фильтр по ОБЪЕКТАМ -->
                    <div class="dropwdown-filter-select" v-if="filterDynamicParams.projectsFilterStart != null">
                        <h3>{{ flatsPage.flats_filters_names.house }}</h3>
                        <div class="curent-value" :class="{'open' : openDropComplexes}">
                            <a href="#" :class="{active : filterDynamicParams.descSelectComplexes === 'all'}" @click.prevent="openDropComplexes = !openDropComplexes, openDropCity = false">{{flatsPage.flats_filters_names.flat_param_all}}</a>
                            <a href="#" class="nowrap-link" :class="{active : filterDynamicParams.descSelectComplexes != 'all'}" @click.prevent="openDropComplexes = !openDropComplexes, openDropCity = false"><p>{{filterDynamicParams.descSelectComplexes}}</p></a>
                            <div class="drop-icon"><svgIcon name="arrow_drop" class="icon-svg"/></div>
                        </div>
                        <div class="dropdown-menu" :class="{'open' : openDropComplexes}">
                            <!-- Шапка конкретного фильтра для мобильной версии -->
                            <div class="menu-top-header" v-if="mobileView">
                                <a href="#" class="link-back" @click.prevent="openDropComplexes = !openDropComplexes">
                                    <svgIcon name="left-arrow" class="icon-arrow-left"/>
                                    <span>{{flatsPage.flats_cards_info.flat_btn_filter_back}}</span>
                                </a>
                                <h3>{{ flatsPage.flats_filters_names.house }}</h3>
                                <a href="#" class="link-reset" @click="setActiveParam('complex', 'all'), openDropComplexes = false">
                                    {{flatsPage.flats_cards_info.flat_btn_filter_reset}}
                                </a>
                            </div>
                            <!--  Дефолтный сброс селекта -->
                            <div class="item-R">
                                <input type="checkbox" :id="'complex_all'" :value="true" v-model="filterDynamicParams.resetComplex">
                                <label :for="'complex_all'" @click="setActiveParam('complex', 'all'), openDropComplexes = false">{{ flatsPage.flats_filters_names.flat_param_all_complexes }}</label>
                            </div>
                            <!-- END -->
                            <div class="item-R" v-for="item in filterDynamicParams.projectsFilterStart">
                                <input type="checkbox" :id="'complex_' + item.code" :value="item.code" v-model="filterDynamicParams.complexesCodeRadioChecked" @change="updateMyValue($event, item)">
                                <label :for="'complex_' + item.code" @click="setSelectedComplexes(item), setActiveParam('complex', item.name)">{{item.name}}</label>
                            </div>
                            <a href="#" class="link-confirm" @click.prevent="openDropComplexes = !openDropComplexes" v-if="isMobileChecker">
                                <span>{{flatsPage.flats_cards_info.flat_btn_filter_agree}}</span>
                            </a>
                        </div>
                    </div>
                    <!-- END -->
                </div>
                <div class="filter-item filter-room">
                    <h3>{{flatsPage.flats_filters_names.room}}</h3>
                    <div class="filter room-items">
                        <!-- @click="e => e.target.classList.toggle('active')" -->
                        <!-- @click="setUpDataClick" -->
                        <!-- :class="{'active' : getActiveClass(item)}" -->
                        <div class="item-R" v-for="item in filter_set_room">
                            <input type="checkbox" :id="'room_' + item" :value="item" v-model="filterDataBase.roomQuantities">
                            <label :for="'room_' + item" @click="setUpDataClick">{{item}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="filter-main">
                <div class="filter-item filter-price">
                    <h3 v-if="globalLang != 'en/'">{{flatsPage.flats_filters_names.price}} <span>тг. за м²</span></h3>
                    <h3 v-else>Price per m²</h3>
                    <div class="input-group">
                        <div class="apper-inputs">
                            <input type="number" v-model="filterDataBase.meterPriceFrom" v-on:keypress="NumbersOnly" @keydown="getNumberReplace" @input="watchInputFrom('priceFilter')" class="left-input">
                            <input type="number" v-model="filterDataBase.meterPriceTo" v-on:keypress="NumbersOnly" @keydown="getNumberReplace" @input="watchInputTo('priceFilter')" class="right-input">
                        </div>
                        <div class="filter" id="PriceFilter">
                            <input type="text" id="price-filter" name="price"  class="ionRangeSlider" value="" />
                        </div>
                    </div>
                </div>
                <div class="filter-item filter-size">
                    <h3>{{flatsPage.flats_filters_names.size}} <span>м²</span></h3>
                    <div class="input-group">
                        <div class="apper-inputs">
                            <input type="number" v-model="filterDataBase.areaFrom" v-on:keypress="NumbersOnly" @input="watchInputFrom('sizeFilter')" class="left-input">
                            <input type="number" v-model="filterDataBase.areaTo" v-on:keypress="NumbersOnly" @input="watchInputTo('sizeFilter')" class="right-input">
                        </div>
                        <div class="filter" id="SizeFilter">
                            <input type="text" id="size-filter" name="size"  class="ionRangeSlider" value="" />
                        </div>
                    </div>
                </div>
                <div class="filter-item filter-floor">
                    <h3>{{flatsPage.flats_filters_names.floor}}</h3>
                    <div class="input-group">
                        <div class="apper-inputs">
                            <input type="number" v-model="filterDataBase.floorRangeStart" v-on:keypress="NumbersOnly" @input="watchInputFrom('floorFilter')" class="left-input">
                            <input type="number" v-model="filterDataBase.floorRangeEnd" v-on:keypress="NumbersOnly" @input="watchInputTo('floorFilter')" class="right-input">
                        </div>
                        <div class="filter" id="FloorFilter">
                            <input type="text" id="floor-filter" name="floor"  class="ionRangeSlider" value="" />
                        </div>
                    </div>
                </div>
                <!-- ONLY FOR HOME PAGE -->
                <div class="filter-item filter-room filter-room-home" v-if="!isMobileChecker && routerName == 'home' || routerName == 'online-booking-details'">
                    <h3>{{flatsPage.flats_filters_names.room}}</h3>
                    <div class="filter room-items">
                        <!-- @click="e => e.target.classList.toggle('active')" -->
                        <!-- @click="setUpDataClick" -->
                        <!-- :class="{'active' : getActiveClass(item)}" -->
                        <div class="item-R" v-for="item in filter_set_room">
                            <input type="checkbox" :id="'room_' + item" :value="item" v-model="filterDataBase.roomQuantities">
                            <label :for="'room_' + item" @click="setUpDataClick">{{item}}</label>
                        </div>
                    </div>
                </div>
                <div class="filter-btn-next" v-if="!mobileView && routerName == 'home' || routerName == 'online-booking-details'">
                    <router-link to="/flats" @click.native="forMetrika()">
                        {{flatsPage.flats_cards_info.flat_btn_view_found_title}}
                    </router-link>
                </div>
                <!-- END ONLY FOR HOME PAGE -->
            </div>

        </div>

        <div class="filter-bottom">
            <div class="search-count">
                {{flatsPage.flats_cards_info.filter_found_title}} <span>{{flatsPagintaion.allApartments}}</span>
            </div>
            <div class="sorting-container">
                <p>{{flatsPage.flats_cards_info.sort_filter_title}}</p>

                <div class="sorting-filter-select sorting-filter-select-rules">
                    <div class="curent-value" :class="{'open' : openDropShortingRules}">
                        <a href="#" @click.prevent="openDropShortingRules = !openDropShortingRules, openDropComplexes = false, openDropCity = false,  openDropShortingParams = false">{{filterDynamicParams.shortingParamsDefault.rule}}</a>
                        <div class="drop-icon"><svgIcon name="arrow_drop" class="icon-svg"/></div>
                    </div>
                    <div class="dropdown-menu dropdown-menu-params" :class="{'open' : openDropShortingRules}">
                        <div class="item-R" v-for="(item, index) in shortingParams.rules" :key="index">
                            <input type="radio" :id="'s_rule_' + item.param" :value="item.param" v-model="filterDataBase.sortedByDirection">
                            <label :for="'s_rule_' + item.param" @click="setActiveSortingParam('shorting_rule', item), openDropShortingRules = false">
                                <span v-if="globalLang == ''">{{item.name}}</span>
                                <span v-if="globalLang == 'kz/'">{{item.name_kz}}</span>
                                <span v-if="globalLang == 'en/'">{{item.name_en}}</span>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="sorting-filter-select sorting-filter-select-params">
                    <div class="curent-value" :class="{'open' : openDropShortingParams}">
                        <a href="#" @click.prevent="openDropShortingParams = !openDropShortingParams, openDropComplexes = false, openDropCity = false,  openDropShortingRules = false">{{filterDynamicParams.shortingParamsDefault.param}}</a>
                        <div class="drop-icon"><svgIcon name="arrow_drop" class="icon-svg"/></div>
                    </div>
                    <div class="dropdown-menu dropdown-menu-params" :class="{'open' : openDropShortingParams}">
                        <div class="item-R" v-for="(item, index) in shortingParams.params" :key="index">
                            <input type="radio" :id="'s_param_' + item.param" :value="item.param" v-model="filterDataBase.sortedByField">
                            <label :for="'s_param_' + item.param" @click="setActiveSortingParam('shorting_param', item), openDropShortingParams = false">
                                <span v-if="globalLang == ''">{{item.name}}</span>
                                <span v-if="globalLang == 'kz/'">{{item.name_kz}}</span>
                                <span v-if="globalLang == 'en/'">{{item.name_en}}</span>
                            </label>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>

        <div class="filter-btn-mobile" v-if="mobileView">
            <a href="#" @click.prevent="closeFilterMobile" 
                v-if="routerName != 'home'"
                v-scroll-to="{
                    el: '.flats-crm-items-container',
                    offset: -100
                }">
                {{flatsPage.flats_cards_info.filter_found_title}} <span v-if="flatsPagintaion.allApartments != null">{{flatsPagintaion.allApartments}}</span> <span v-else>0</span>
                <!-- <span>28</span> КВАРТИР -->
            </a>
            <router-link to="/flats" v-else> {{flatsPage.flats_cards_info.filter_found_title}} <span v-if="flatsPagintaion.allApartments != null">{{flatsPagintaion.allApartments}}</span><span v-else>0</span></router-link>
        </div>
    </div>
</template>

<script>
    import flatsBtnsView from '@/components/flats-crm/flats-crm-btns.vue'
    import flatsBookingCounter from '@/components/flats-crm/flats-crm-book-counter.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    // import store from '@/store.js'
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-CRM-flats-filter',
        props: ['mobileView'],
        components: {
            flatsBtnsView,
            flatsBookingCounter,
            svgIcon,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                globalLang: window.GlobalLang,
                filterData: null,
                openDropCity: false,
                openDropComplexes: false,
                openDropShortingParams: false,
                openDropShortingRules: false,
                cityActive: 'all',
                complexActive: 'all',
                // Переменные хранения стандартных статичных данных
                filter_set_room: ['1', '2', '3', '4'], // дефолтные значения комнатности 
                filterDataDefault: {},
                //
                FloorFilter: null,
                SizeFilter: null,
                PriceFilter: null,
                shortingParams: {
                    params: [
                        {
                            name: 'Комнатности',
                            name_kz: 'Бөлмелер саны',
                            name_en: 'Number of rooms',
                            param: 'ROOM',
                        },
                        {
                            name: 'Стоимости',
                            name_kz: 'Құны',
                            name_en: 'Cost',
                            param: 'PRICE',
                        },
                        {
                            name: 'Этажности',
                            name_kz: 'Қабаты',
                            name_en: 'Number of floors',
                            param: 'FLOOR',
                        },
                        {
                            name: 'Площади',
                            name_kz: 'Алаңы',
                            name_en: 'Area',
                            param: 'AREA',
                        },
                    ],
                    rules: [
                        {
                            name: 'Убыванию',
                            name_kz: 'Азаюы',
                            name_en: 'Descending',
                            param: 'DESCENDING',
                        },
                        {
                            name: 'Возрастанию',
                            name_kz: 'Өсу',
                            name_en: 'Ascending',
                            param: 'ASCENDING',
                        }
                    ]
                },
            }
        },
        computed: mapGetters({
            flatsPage: 'loadFlatsPage',
            projectItems: 'loadProjectItemsDefault',
            filterDataBase: 'loadFilterData',
            filterDynamicParams: 'loadFilterDynamicParam',
            filterMinMaxParams: 'loadFilterMinMaxParams',
            flatsPagintaion: 'loadFlatsPagination',
            isMobileChecker: 'loadIsMobileChecker',
            onlinePageSetUp: 'loadOnlineBoockingPage',
            
            // salesCardPage: 'loadSalesCardPage',
            // paginPageNumber: 'loadPaginPageNumber',
            // resetModeTrigger: 'loadResetTriggerMove',
            // salesCardFlats: 'loadFlatsCardsGlobal',
            // salesCardFlatsDefault: 'loadFlatsCardsGlobalDefault',
        }),
        methods: {
            updateMyValue(event, arr) {
                if (arr.slug_name == 'landmark') {
                    var dataFind = this.filterDynamicParams.complexesCodeRadioChecked;
                    const findLDMstr = dataFind.filter(function( obj ) {
                        return obj == 'LDM, LDM-II, LDM-IV';
                    });
                    if (findLDMstr.length) {
                        // console.log(dataFind, findLDMstr, 'asdasda')
                        this.filterDynamicParams.complexesCodeRadioChecked.push('LDM', 'LDM-II', 'LDM-IV');
                        this.updateFilterDataBase();
                        // console.log(dataFind)
                    } else {
                        const findLDMstr = dataFind.filter(function( obj ) {
                            return obj !== 'LDM' &&
                                    obj !== 'LDM-II' &&
                                    // obj !== 'LDM-III' &&
                                    obj !== 'LDM-IV' 
                        });
                        this.filterDynamicParams.complexesCodeRadioChecked = findLDMstr;
                        // console.log('HAHAHAH')
                        // console.log(findLDMstr, 'asdasdasd');
                        this.updateFilterDataBase();
                        // console.log(dataFind, 'asdasdasdasd')
                    }

                    // console.log(event, arr)
                    // var arrCodes = ['AKV', 'RIV', 'ALF', 'ORI'];
                    // arrCodes.push('LDM')
                    // console.log(arrCodes, 'ARR CODES');
                    // console.log(this.filterDynamicParams.complexesCodeRadioChecked)
                    // this.$store.commit('FilterDataUpdate', { type: 'complexCodes', param: 'landmark', data: ['LDM', 'LDM-II', 'LDM-III', 'LDM-IV'] });
                }
            },
            // Сборка фильтра из исходных данных по всем ЖК включенным в систему
            buildProjectsFilter() { // сборка фильтра по жк
                // console.log('BUILD AJHAJAJAJ')
                this.$store.commit('filterDynamicParamsUpdate', { param: 'projectFilterItems', type: 'itemsDefault', data: [] });
                var dataProjects = this.projectItems,
                    itemsProject = [],
                    itemsProjectRebuild = [],
                    cityCode;

                itemsProject = dataProjects.filter(item => {
                    return item.project_stie_flats_filter_init == 'true'
                });

                this.$store.commit('filterDynamicParamsUpdate', { param: 'projectFilterItems', type: 'itemsDefault', data: itemsProject });
                this.$store.commit('filterDynamicParamsUpdate', { param: 'sortProjectItems'});
                
                // console.log(this.filterDynamicParams.projectsFilterDefault, 'project filter default')
                // // Сортировка значений по алфавиту
                this.buildCityFilter(this.filterDynamicParams.projectsFilterDefault); // запускаем сборку фильтра по городам
                this.$store.commit('setFilterRangeMinMaxParams', this.filterDynamicParams.projectsFilterDefault); // запускаем перебор минимальных и максимальных данных для фильтра единожды
                if (this.$store.state.flatsItems == null) { // вызываем функцию деволтного запроса квартир по исходным параметрам
                    // console.log(this.filterData, 'FILTER DATA IN DEFAULT REQUEST')
                    this.updateFilterDataBase();
                    this.getItemsDefault();
                }

                // перебор массива для добавления кодов городов СРМ и добавления в состояние дефолт даты кодов жк срм
                for (var i=0; i < this.filterDynamicParams.projectsFilterDefault.length; i++) {
                    this.$store.commit('FilterDataUpdate', {type: 'complexCodesDefault', data: this.filterDynamicParams.projectsFilterDefault[i].crm_code}) // добавление всех объектов в дефолтный запрос
                    this.$store.commit('filterDynamicParamsUpdate', { param: 'projectFilterItems', type: 'itemsComplexDefault', data: this.filterDynamicParams.projectsFilterDefault[i] }); // добавление всех объектов в дефолтную переменную комплексов
                    // console.log( this.filterDynamicParams.projectsFilterComplexesDefault, ' this.projectsFilterComplexesDefault')
                    if (this.filterDynamicParams.projectsFilterDefault[i].city_name.name == 'Алматы') {
                        cityCode = 'ALM';
                    } else if (this.filterDynamicParams.projectsFilterDefault[i].city_name.name == 'Астана') {
                        cityCode = 'NUR';
                    } else if (this.filterDynamicParams.projectsFilterDefault[i].city_name.name == 'Шымкент') {
                        cityCode = 'SHM';
                    } else if (this.filterDynamicParams.projectsFilterDefault[i].city_name.name == 'Туркестан') {
                        cityCode = 'TR';
                    } else if (this.filterDynamicParams.projectsFilterDefault[i].city_name.name == 'Актау') {
                        cityCode = 'MAN';
                    } else if (this.filterDynamicParams.projectsFilterDefault[i].city_name.name == 'Ташкент') {
                        cityCode = 'TAS';
                    }

                    // if (this.filterDynamicParams.projectsFilterDefault[i].project_name.slug == 'landmark') {
                        // console.log(this.filterDynamicParams.projectsFilterDefault[i].project_name.slug)
                    itemsProjectRebuild.push({
                        'name': this.filterDynamicParams.projectsFilterDefault[i].project_name.name,
                        'slug_name': this.filterDynamicParams.projectsFilterDefault[i].project_name.slug,
                        'code': this.filterDynamicParams.projectsFilterDefault[i].crm_code,
                        'city_code': cityCode,
                        'filter_set_floor' : this.filterDynamicParams.projectsFilterDefault[i].filter_set_floor,
                        'filter_set_money' : this.filterDynamicParams.projectsFilterDefault[i].filter_set_money,
                        'filter_set_room' : this.filterDynamicParams.projectsFilterDefault[i].filter_set_room,
                        'filter_set_size' : this.filterDynamicParams.projectsFilterDefault[i].filter_set_size,
                        'project_stie_shablon_price_flats_init' : this.filterDynamicParams.projectsFilterDefault[i].project_stie_shablon_price_flats_init,
                    });
                    
                    
                    // else if (this.filterDynamicParams.projectsFilterDefault[i].project_name.slug == 'akvarel') {
                    //     itemsProjectRebuild.push({
                    //         'name': this.filterDynamicParams.projectsFilterDefault[i].project_name.name,
                    //         'slug_name': this.filterDynamicParams.projectsFilterDefault[i].project_name.slug,
                    //         'code': this.filterDynamicParams.projectsFilterDefault[i].crm_code,
                    //         'city_code': cityCode,
                    //         'filter_set_floor' : this.filterDynamicParams.projectsFilterDefault[i].filter_set_floor,
                    //         'filter_set_money' : this.filterDynamicParams.projectsFilterDefault[i].filter_set_money,
                    //         'filter_set_room' : this.filterDynamicParams.projectsFilterDefault[i].filter_set_room,
                    //         'filter_set_size' : this.filterDynamicParams.projectsFilterDefault[i].filter_set_size,
                    //         'project_stie_shablon_price_flats_init' : this.filterDynamicParams.projectsFilterDefault[i].project_stie_shablon_price_flats_init,
                    //     });
                    // }
                    // else {
                    //     itemsProjectRebuild.push({
                    //         'name': this.filterDynamicParams.projectsFilterDefault[i].project_name.name,
                    //         'slug_name': this.filterDynamicParams.projectsFilterDefault[i].project_name.slug,
                    //         'code': ['LDM', 'LDM-II'],
                    //         'city_code': cityCode,
                    //         'filter_set_floor' : this.filterDynamicParams.projectsFilterDefault[i].filter_set_floor,
                    //         'filter_set_money' : this.filterDynamicParams.projectsFilterDefault[i].filter_set_money,
                    //         'filter_set_room' : this.filterDynamicParams.projectsFilterDefault[i].filter_set_room,
                    //         'filter_set_size' : this.filterDynamicParams.projectsFilterDefault[i].filter_set_size,
                    //         'project_stie_shablon_price_flats_init' : this.filterDynamicParams.projectsFilterDefault[i].project_stie_shablon_price_flats_init,
                    //     });
                    // }
                    
                }

                // ДОБАВЛЕНИЕ ТЕСТОВЫХ ЖК В ФИЛЬТР
                // itemsProjectRebuild.push( 
                //     { 
                //         'name': 'TEST ROCKET_ALA',
                //         'slug_name': 'austria',
                //         'code': 'RCT',
                //         'city_code': 'ALM',
                //         'filter_set_floor' : {
                //             'min': 1,
                //             'max': 30,
                //         },
                //         'filter_set_money' : {
                //             'min': 100000,
                //             'max': 900000,
                //         },
                //         'filter_set_room' : [{number: 1},{number: 2},{number: 3},{number: 4}],
                //         'filter_set_size' : {
                //             'min': 20,
                //             'max': 200,
                //         },
                //         'project_stie_shablon_price_flats_init' : 'true',
                //     },
                // );
                this.$store.commit('filterDynamicParamsUpdate', { param: 'projectFilterItems', type: 'itemsDefault', data: itemsProjectRebuild });
                this.$store.commit('filterDynamicParamsUpdate', { param: 'projectFilterItems', type: 'itemsStart', data: itemsProjectRebuild });


                // console.log(this.projectsFilterDefault, 'this.projectsFilterDefault')

                // console.log(this.projectsFilterDefault, 'aasdasdasd')
                // console.log(itemsProjectRebuild);
                // перебор массива для добавления кодов ЖК СРМ
                // itemsProject = [];
                // for (var i=0; i < this.projectsFilterDefault.length; i++) {
                //     itemsProject.push({
                //         name: this.projectsFilterDefault[i].project_name.name,
                //         slug_name: this.projectsFilterDefault[i].project_name.slug,
                //         code: this.projectsFilterDefault[i].crm_code,
                //         city: this.projectsFilterDefault[i].crmCityCode
                //     });
                // }
                // console.log(this.projectsFilterDefault, itemsProject);
            },
            buildCityFilter(arr) { // сборка фильтра по городам
                this.cityFilterDefault = [];
                var dataProjects = arr,
                    itemsCity = [],
                    cityCode;

                for (var i=0; i < dataProjects.length; i++) {
                    itemsCity.push(dataProjects[i].city_name.name);
                }
                this.cityFilterDefault = this.uniqueElementsInArray(itemsCity);
                this.cityFilterDefault.sort();
                // перебор массива для добавления кодов городов СРМ
                itemsCity = [];
                for (var i=0; i < this.cityFilterDefault.length; i++) {
                    if (this.cityFilterDefault[i] == 'Алматы') {
                        cityCode = 'ALM';
                    } else if (this.cityFilterDefault[i] == 'Астана') {
                        cityCode = 'NUR';
                    } else if (this.cityFilterDefault[i] == 'Шымкент') {
                        cityCode = 'SHM';
                    } else if (this.cityFilterDefault[i] == 'Туркестан') {
                        cityCode = 'TR';
                    } else if (this.cityFilterDefault[i] == 'Актау') {
                        cityCode = 'MAN';
                    } else if (this.cityFilterDefault[i] == 'Ташкент') {
                        cityCode = 'TAS';
                    }
                    itemsCity.push({
                        city: this.cityFilterDefault[i],
                        code: cityCode,
                    });
                }
                this.cityFilterDefault = itemsCity;
                this.$store.commit('filterDynamicParamsUpdate', { param: 'cityFilterDefault', data: itemsCity });

                // Добавление тестовых городов
                // this.cityFilterDefault.push( 
                //     {
                //         city: "Актау",
                //         code: "MAN"
                //     },
                //     {
                //         city: "Ташкент",
                //         code: "TAS"
                //     }
                // );
                // console.log(this.cityFilterDefault);
            },
            //  Фильтруем комплексы при выборе города или при изменения выбора города
            filterComplexesInDrop(code) {
                this.$store.commit('FilterDataUpdate', {param: 'reset', type: 'complexCodes', data: []})
                this.$store.commit('FilterDataUpdate', {type: 'roomQuantities', data: []})
                this.$store.commit('filterDynamicParamsUpdate', { param: 'complex', data: 'all' });
                this.$store.commit('filterDynamicParamsUpdate', { param: 'complexReset', data: true });
                this.$store.commit('filterDynamicParamsUpdate', { param: 'descComplexes', data: 'all' });

                var dataProjects = this.filterDynamicParams.projectsFilterDefault,
                    filterComplexes;
                if (code != 'all') {
                    filterComplexes = dataProjects.filter(item => {
                        return item.city_code == code;
                    });
                    this.$store.commit('filterDynamicParamsUpdate', { param: 'projectFilterItems', type: 'itemsStart', data: filterComplexes });
                    for (var i=0; i < this.filterDynamicParams.projectsFilterStart.length; i++) {
                        // console.log(this.filterDynamicParams.projectsFilterStart[i].code, 'asdasd')
                        this.$store.commit('FilterDataUpdate', {param: 'push', type: 'complexCodes', data: this.filterDynamicParams.projectsFilterStart[i].code})

                    }
                } else {
                    filterComplexes = dataProjects;
                    this.$store.commit('filterDynamicParamsUpdate', { param: 'projectFilterItems', type: 'itemsStart', data: filterComplexes });
                     for (var i=0; i < this.filterDynamicParams.projectsFilterStart.length; i++) {
                        this.$store.commit('FilterDataUpdate', {param: 'push', type: 'complexCodes', data: this.filterDynamicParams.projectsFilterStart[i].code})
                    }
                }
                // console.log(this.projectsFilterDefault, filterComplexes, 'FILTER COMPLEXES')
                this.$store.commit('setFilterRangeMinMaxParams', filterComplexes);
                this.resetIONrangeSlider();
                this.updateFilterDataBase();
            },
            // добавляем или убираем из массива выбранные жилые комплексы для фильтрации 
            // что бы в дальнейшем согласно выборке делать сортировку фильтровых значений
            setSelectedComplexes(arr) { //
                // console.log(arr, 'SET SELECTED COMPLEXES')
                var defultItems = this.filterDynamicParams.projectsFilterComplexesDefault;
                setTimeout(() => {
                    this.$store.commit('FilterDataUpdate', {param: 'update', type: 'complexCodes', data: this.filterDynamicParams.complexesCodeRadioChecked})
                }, 50);
                this.$store.commit('filterDynamicParamsUpdate', { param: 'descComplexes', data: this.filterDynamicParams.descSelectComplexes.replace('all', '') });
                // console.log(this.filterDynamicParams)

                var findItem = this.filterDynamicParams.selectedComplexes.find(x => x.code === arr.code);
                // console.log(findItem)
                if (findItem == undefined) {
                    this.$store.commit('filterDynamicParamsUpdate', { param: 'setSelectedComplexes', data: arr, type: 'push'});
                    this.$store.commit('filterDynamicParamsUpdate', { param: 'descComplexes', data: this.filterDynamicParams.descSelectComplexes + arr.name + ' / ' });
                } else  {
                    this.$store.commit('filterDynamicParamsUpdate', { param: 'setSelectedComplexes', data: arr.code, type: 'filter'});
                    this.$store.commit('filterDynamicParamsUpdate', { param: 'descComplexes', data: this.filterDynamicParams.descSelectComplexes.replace(arr.name + ' / ', '') });
                }
                if (this.filterDynamicParams.selectedComplexes.length == 0) {
                    // console.log('EMPTY VAR')
                    if (this.cityActive != 'all') {
                        var filterItems = defultItems.filter((item) => {
                            return item.city_name.name == this.cityActive
                        });
                        for (var i=0; i < filterItems.length; i++) {
                            // console.log('asdasdasd')
                            this.$store.commit('FilterDataUpdate', {param: 'push', type: 'complexCodes', data: filterItems[i].crm_code})
                        }
                    } else {
                        for (var i=0; i < defultItems.length; i++) {
                            // console.log('232323232')
                            this.$store.commit('FilterDataUpdate', {param: 'push', type: 'complexCodes', data: defultItems[i].crm_code})
                        } 
                    }
                    setTimeout(() => {
                        this.$store.commit('setFilterRangeMinMaxParams', this.filterDynamicParams.projectsFilterStart);
                        this.resetIONrangeSlider();
                        this.$store.commit('filterDynamicParamsUpdate', { param: 'complex', data: 'all' });
                        this.$store.commit('filterDynamicParamsUpdate', { param: 'complexReset', data: true });
                        this.$store.commit('filterDynamicParamsUpdate', { param: 'descComplexes', data: 'all' });
                        this.updateFilterDataBase();
                        // console.log('asdasdasd 000000000000000000')
                    }, 70);
                } else {
                    // console.log('FULL', this.selectedComplexes)
                    this.$store.commit('setFilterRangeMinMaxParams', this.filterDynamicParams.selectedComplexes);
                    this.resetIONrangeSlider();
                    this.$store.commit('filterDynamicParamsUpdate', { param: 'complexReset', data: false });
                    this.updateFilterDataBase();
                }
                // console.log(this.filterData, 'FILTRE DATA SET COMPLEX')
                // console.log(this.selectedComplexes, this.descSelectComplexes, 'TRUE')
            },
            // изменения заголовка в select dropdown фильтра города и объектов жк
            setActiveParam(param, data) {
                // console.log(param, data, 'test INDEX');
                var defultItems = this.filterDynamicParams.projectsFilterComplexesDefault;
                if (param == 'city') {
                    if (data != 'all') {
                        this.$store.commit('filterDynamicParamsUpdate', { 'param': param, 'data': data });
                        // console.log(param, data)
                    } else {
                        this.$store.commit('filterDynamicParamsUpdate', { 'param': param, 'data': data });
                        this.$store.commit('FilterDataUpdate', {param: 'reset', type: 'cityCodes', data: []})

                    }
                } else {
                    if (data == 'all') {
                        this.complexActive = 'all';
                        this.$store.commit('filterDynamicParamsUpdate', { 'param': param, 'data': data });
                        this.$store.commit('FilterDataUpdate', {param: 'reset', type: 'complexCodes', data: []})
                        if (this.cityActive != 'all') {
                            var filterItems = defultItems.filter((item) => {
                                return item.city_name.name == this.filterDynamicParams.cityActive
                            });
                            for (var i=0; i < filterItems.length; i++) {
                                // console.log('3333333')
                                this.$store.commit('FilterDataUpdate', {param: 'push', type: 'complexCodes', data: filterItems[i].crm_code})
                            }
                        } else {
                            for (var i=0; i < defultItems.length; i++) {
                                // console.log('444444')
                                this.$store.commit('FilterDataUpdate', {param: 'push', type: 'complexCodes', data: defultItems[i].crm_code})
                            }
                        }
                        // console.log(this.cityActive, 'this.cityActive')
                        // console.log(projectItems, 'PROJECT ITEMS FILTER')
                        if (this.filterDynamicParams.selectedComplexes.length == 0) {
                            // console.log('EMPTY VAR')
                            this.$store.commit('setFilterRangeMinMaxParams', this.filterDynamicParams.projectsFilterStart);
                            this.resetIONrangeSlider();
                            this.$store.commit('filterDynamicParamsUpdate', { 'param': 'descComplexes', 'data': 'all' });
                            this.updateFilterDataBase();
                            // console.log(this.filterData, 'ASASDASDASDS')
                        }
                    } else {
                        this.complexActive = data;
                    }
                }
                
            },
            // изменения полей сортировки о обновление фильтра после изменений в фильтах "сортировка"
            setActiveSortingParam(param, data) {
                // console.log(param, data)
                this.$store.commit('filterDynamicParamsUpdate', { 'param': param, 'data': data });
                this.updateFilterDataBase();
            },
            // Сборка RANGE фильтров ЭТАЖ/ ПЛОЩАДЬ/ СТОИМОСТЬ
            BuildIonRangeSlider() {
                var _self = this;
                // console.log(_self.filterMinMaxParams, '212312312123123')
                _self.FloorFilter = $("#floor-filter");
                _self.SizeFilter = $('#size-filter');
                _self.PriceFilter = $('#price-filter');
                
                _self.FloorFilter.ionRangeSlider({
                    type: "double",
                    min: _self.filterMinMaxParams.floor.min,
                    max: _self.filterMinMaxParams.floor.max,
                    from: _self.filterDataBase.floorRangeStart,
                    to: _self.filterDataBase.floorRangeEnd,
                    step: 1,
                    hide_min_max: true,
                    onChange: function (data) {
                        _self.$store.commit('FilterDataUpdate', {type: 'floor-filter', min: data.from, max: data.to})
                        _self.updateFilterDataBase();
                        // console.log(_self.filterData, 'TEST')
                    },
                    onUpdate: function (data) {
                        // console.log(data, 'update')
                        _self.$store.commit('FilterDataUpdate', {type: 'floor-filter', min: data.from, max: data.to})
                        _self.updateFilterDataBase();
                    },
                });
                _self.SizeFilter.ionRangeSlider({
                    type: "double",
                    min: _self.filterMinMaxParams.size.min,
                    max: _self.filterMinMaxParams.size.max,
                    from: _self.filterDataBase.areaFrom,
                    to: _self.filterDataBase.areaTo,
                    step: 1,
                    hide_min_max: true,
                    onChange: function (data) {
                        _self.$store.commit('FilterDataUpdate', {type: 'size-filter', min: data.from, max: data.to})
                        _self.updateFilterDataBase();
                    },
                    onUpdate: function (data) {
                        // console.log(data, 'update')
                        _self.$store.commit('FilterDataUpdate', {type: 'size-filter', min: data.from, max: data.to})
                        _self.updateFilterDataBase();
                    },
                });
                _self.PriceFilter.ionRangeSlider({
                    type: "double",
                    min: _self.filterMinMaxParams.price.min,
                    max: _self.filterMinMaxParams.price.max,
                    from: _self.filterDataBase.meterPriceFrom,
                    to: _self.filterDataBase.meterPriceTo,
                    step: 1000,
                    hide_min_max: true,
                    onChange: function (data) {
                        _self.$store.commit('FilterDataUpdate', {type: 'price-filter', min: data.from, max: data.to})
                        _self.updateFilterDataBase();
                    },
                    onUpdate: function (data) {
                        // console.log(data, 'update')
                        _self.$store.commit('FilterDataUpdate', {type: 'price-filter', min: data.from, max: data.to})
                        _self.updateFilterDataBase();
                    },
                });

                this.setComplexDataByURL();
            },
            // сброс всех range фильтров при динамических изменения данных мимальных и максимальных значениях фильтра
            resetIONrangeSlider() {
                var _self = this;
                _self.FloorFilter.data("ionRangeSlider").update({
                    min: _self.filterMinMaxParams.floor.min,
                    max: _self.filterMinMaxParams.floor.max,
                    from: _self.filterMinMaxParams.floor.min,
                    to: _self.filterMinMaxParams.floor.max,
                });
                _self.SizeFilter.data("ionRangeSlider").update({
                    min: _self.filterMinMaxParams.size.min,
                    max: _self.filterMinMaxParams.size.max,
                    from: _self.filterMinMaxParams.size.min,
                    to: _self.filterMinMaxParams.size.max,
                });
                _self.PriceFilter.data("ionRangeSlider").update({
                    min: _self.filterMinMaxParams.price.min,
                    max: _self.filterMinMaxParams.price.max,
                    from: _self.filterMinMaxParams.price.min,
                    to: _self.filterMinMaxParams.price.max,
                });
            },

            setComplexDataByURL() { // Если был выполнен переход с страницы В продаже то подставляем в фильтр значение из URL
                var complex = new URL(window.location.href).searchParams.get('complex-code');
                if (complex != null) {
                    this.$store.commit('FilterDataUpdate', {param: 'reset', type: 'complexCodes', data: []})
                    this.$store.commit('filterDynamicParamsUpdate', { param: 'descComplexes', data: this.filterDynamicParams.descSelectComplexes.replace('all', '') });
                    this.$store.commit('filterDynamicParamsUpdate', { param: 'complex', data: 'all' });

                    // this.filterData.complexCodes = [];
                    // this.complexesCodeRadioChecked = [];
                    // console.log(complex, this.filterDynamicParams.projectsFilterDefault)
                    var DataCompelxes = this.filterDynamicParams.projectsFilterDefault;
                    var filterProject = DataCompelxes.filter(item => {
                        return item.code == complex
                    });
                    // console.log(filterProject, complex)
                    if (filterProject.length > 0) {
                        // console.log(complex, filterProject)
                        // this.filterData.complexCodes.push(complex);
                        // this.complexesCodeRadioChecked.push(complex);
                        this.$store.commit('filterDynamicParamsUpdate', { param: 'complex', data: 'url_push', arr:  complex,});
                        this.setSelectedComplexes(filterProject[0]);
                        this.setActiveParam('complex', filterProject[0].name);
                    }
                }
                // console.log(filterProject[0], 'TEST FROM NEW FUNCTION')
            },
            setUpDataClick() {
                this.updateFilterDataBase();
            },
            updateFilterDataBase() { // Обновляем данные фильтра в хранилище данных
                this.$store.commit('FilterDataUpdate', {type: 'pageNumber', number: 1})
                this.$store.commit('UpdatePaginPageNumber', 1);
                // console.log(this.filterDataBase, 'DATA FILTER STORE')
                setTimeout(() => {
                    this.getItemsFlatsByFilter();
                }, 300);
                // console.log(this.filterData);
            },
            getItemsDefault() {
                this.$store.dispatch('getFlatsItems', this.filterDataBase);
                this.$store.dispatch('getFlatsPagintationCounters', this.filterDataBase);
            },
            getItemsFlatsByFilter() {
                this.$store.dispatch('getFlatsByFilter', this.filterDataBase);
                this.$store.dispatch('getFlatsPagintationCounters', this.filterDataBase);
            },
            ///////
            getActiveClass(elem) {
                // console.log(elem);
                var data = this.filterDataBase.roomQuantities;
                var filter = data.filter(item => {
                    return item == elem.number
                });
                // console.log(filter);
                if (filter.length > 0)
                return true;
                
            },
            closeFilterMobile() {
                window.body.removeClass('overflowTrue');
                document.getElementById('header').classList.remove('notvisibleSalesLand');
                document.getElementById('footer').classList.remove('notvisibleSalesLand');
				this.$store.commit('SetVisibleFilterMobile', false);
            },
            uniqueElementsInArray(arr) {
                let result = [];
                for (let str of arr) {
                    // console.log(str, 'unique')
                    if (!result.includes(str)) {
                        result.push(str);
                    }
                }
                return result;
            },
            watchInputFrom(param) {
                var _self = this;
                _self.FloorFilter = $("#floor-filter");
                _self.SizeFilter = $('#size-filter');
                _self.PriceFilter = $('#price-filter');
                if (param == 'floorFilter') {
                    setTimeout(() => {
                        if (parseInt(this.filterDataBase.floorRangeStart) < this.filterMinMaxParams.floor.min) { this.filterDataBase.floorRangeStart = this.filterMinMaxParams.floor.min} 
                        else if (parseInt(this.filterDataBase.floorRangeStart) > parseInt(this.filterDataBase.floorRangeEnd)) {this.filterDataBase.floorRangeStart = this.filterDataBase.floorRangeEnd}
                        else if (this.filterDataBase.floorRangeStart == '') {this.filterDataBase.floorRangeStart = this.filterMinMaxParams.floor.min}
                        _self.FloorFilter.data("ionRangeSlider").update({
                            from: _self.filterDataBase.floorRangeStart,
                        });
                    }, 1000);
                } else if (param == 'sizeFilter') {
                    setTimeout(() => {
                        if (parseInt(this.filterDataBase.areaFrom) < this.filterMinMaxParams.size.min) { this.filterDataBase.areaFrom = this.filterMinMaxParams.size.min} 
                        else if (parseInt(this.filterDataBase.areaFrom) > parseInt(this.filterDataBase.areaTo)) {this.filterDataBase.areaFrom = this.filterDataBase.areaTo}
                        else if (this.filterDataBase.areaFrom == '') {this.filterDataBase.areaFrom = this.filterMinMaxParams.size.min}
                        _self.SizeFilter.data("ionRangeSlider").update({
                            from: _self.filterDataBase.areaFrom,
                        });
                    }, 1000);
                } else if (param == 'priceFilter') {
                    setTimeout(() => {
                        if (parseInt(this.filterDataBase.meterPriceFrom) < this.filterMinMaxParams.price.min) { this.filterDataBase.meterPriceFrom = this.filterMinMaxParams.price.min} 
                        else if (parseInt(this.filterDataBase.meterPriceFrom) > parseInt(this.filterDataBase.meterPriceTo)) {this.filterDataBase.meterPriceFrom = this.filterDataBase.meterPriceTo}
                        else if (this.filterDataBase.meterPriceFrom == '') {this.filterDataBase.meterPriceFrom = this.filterMinMaxParams.price.min}
                        _self.PriceFilter.data("ionRangeSlider").update({
                            from: _self.filterDataBase.meterPriceFrom,
                        });
                    }, 3000);
                }
            },
            watchInputTo(param) {
                var _self = this;
                _self.FloorFilter = $("#floor-filter");
                _self.SizeFilter = $('#size-filter');
                _self.PriceFilter = $('#price-filter');
                if (param == 'floorFilter') {
                    setTimeout(() => {
                        if (parseInt(this.filterDataBase.floorRangeEnd) > this.filterMinMaxParams.floor.max) { this.filterDataBase.floorRangeEnd = this.filterMinMaxParams.floor.max} 
                        else if (parseInt(this.filterDataBase.floorRangeEnd) < this.filterMinMaxParams.floor.min) {this.filterDataBase.floorRangeEnd = this.filterDataBase.floorRangeStart}
                        else if (parseInt(this.filterDataBase.floorRangeEnd) < parseInt(this.filterDataBase.floorRangeStart)) {this.filterDataBase.floorRangeEnd = this.filterDataBase.floorRangeStart}
                        else if (this.filterDataBase.floorRangeEnd == '') {this.filterDataBase.floorRangeEnd = this.filterMinMaxParams.floor.max}
                        _self.FloorFilter.data("ionRangeSlider").update({
                            to: _self.filterDataBase.floorRangeEnd
                        });
                    }, 1000);
                } else if (param == 'sizeFilter') {
                    setTimeout(() => {
                        if (parseInt(this.filterDataBase.areaTo) > this.filterMinMaxParams.size.max) { this.filterDataBase.areaTo = this.filterMinMaxParams.size.max} 
                        else if (parseInt(this.filterDataBase.areaTo) < this.filterMinMaxParams.size.min) {this.filterDataBase.areaTo = this.filterDataBase.areaFrom}
                        else if (parseInt(this.filterDataBase.areaTo) < parseInt(this.filterDataBase.areaFrom)) {this.filterDataBase.areaTo = this.filterDataBase.areaFrom}
                        else if (this.filterDataBase.areaTo == '') {this.filterDataBase.areaTo = this.filterMinMaxParams.size.max}
                        _self.SizeFilter.data("ionRangeSlider").update({
                            to: _self.filterDataBase.areaTo
                        });
                    }, 1000);
                } else if (param == 'priceFilter') {
                    setTimeout(() => {
                        if (parseInt(this.filterDataBase.meterPriceTo) > this.filterMinMaxParams.price.max) { this.filterDataBase.meterPriceTo = this.filterMinMaxParams.price.max} 
                        else if (parseInt(this.filterDataBase.meterPriceTo) < this.filterMinMaxParams.price.min) {this.filterDataBase.meterPriceTo = this.filterDataBase.meterPriceFrom}
                        else if (parseInt(this.filterDataBase.meterPriceTo) < parseInt(this.filterDataBase.meterPriceFrom)) {this.filterDataBase.meterPriceTo = this.filterDataBase.meterPriceFrom}
                        else if (this.filterDataBase.meterPriceTo == '') {this.filterDataBase.meterPriceTo = this.filterMinMaxParams.price.max}
                        _self.PriceFilter.data("ionRangeSlider").update({
                            to: _self.filterDataBase.meterPriceTo
                        });
                    }, 3000);
                }
            },
            NumbersOnly(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },
            getNumberReplace() {
                // console.log('asdasdasd')
                // return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            }, 
            forMetrika() {
                // console.log('work');
                ym(57579163,'reachGoal','show_flats_home_page')
            },
            closeFilterMobile() {
                window.body.removeClass('overflowTrue');
                document.getElementById('header').classList.remove('notvisibleSalesLand');
                document.getElementById('footer').classList.remove('notvisibleSalesLand');
                this.$store.commit('SetVisibleFilterMobile', false);  
            },
            getWrap_ofSTR(str) {
                return str.toString().split('').map(char => /\d/.test(char) ? `<span>${char}</span>` : char).join('');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.filterDataDefault = this.filterDataBase;
            if (this.filterMinMaxParams.init == false) { 
                this.buildProjectsFilter();
            }
            this.BuildIonRangeSlider(); // Собираем слайдеры бегунки фильтры
            this.setActiveSortingParam('shorting_rule', this.shortingParams.rules[1]);
            this.setActiveSortingParam('shorting_param', this.shortingParams.params[0]);
            // this.buildCityFilter();
            // this.setFilterDataBase();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-filter.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-filter-respond.scss';
</style>